var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21875 8.78125C5.71875 9.25 6.3125 9.48438 7 9.48438C7.6875 9.48438 8.26562 9.25 8.73438 8.78125C9.23438 8.28125 9.48438 7.6875 9.48438 7C9.48438 6.3125 9.23438 5.73438 8.73438 5.26562C8.26562 4.76562 7.6875 4.51562 7 4.51562C6.3125 4.51562 5.71875 4.76562 5.21875 5.26562C4.75 5.73438 4.51562 6.3125 4.51562 7C4.51562 7.6875 4.75 8.28125 5.21875 8.78125ZM2.03125 2.07812C3.40625 0.703125 5.0625 0.015625 7 0.015625C8.9375 0.015625 10.5781 0.703125 11.9219 2.07812C13.2969 3.42188 13.9844 5.0625 13.9844 7C13.9844 7.96875 13.7344 9.07812 13.2344 10.3281C12.7656 11.5781 12.1875 12.75 11.5 13.8438C10.8125 14.9375 10.125 15.9688 9.4375 16.9375C8.78125 17.875 8.21875 18.625 7.75 19.1875L7 19.9844C6.8125 19.7656 6.5625 19.4844 6.25 19.1406C5.9375 18.7656 5.375 18.0469 4.5625 16.9844C3.75 15.8906 3.03125 14.8438 2.40625 13.8438C1.8125 12.8125 1.26562 11.6562 0.765625 10.375C0.265625 9.09375 0.015625 7.96875 0.015625 7C0.015625 5.0625 0.6875 3.42188 2.03125 2.07812Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionIcon);
export default __webpack_public_path__ + "static/media/Position_icon.f30f79a1166700f6eb9c91d924425f6f.svg";
export { ForwardRef as ReactComponent };